import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  image: {
    height: "100%",
    position: "relative",
    "& span:first-child": {
      height: "100% !important",
      width: "100% !important",
    },
  },
}));

export default useStyles;
